import { useCallback, useEffect, useMemo, useState } from 'react'

export default function useResponsiveDimensions(containerRef, watchElResize = true) {
  const [dimensions, setDimensions] = useState({ height: 0, width: 0 })

  const updateDimensions = useCallback(() => {
    if (containerRef.current) {
      const { height, width } = containerRef.current.getBoundingClientRect()
      setDimensions({ height, width })
    }
  }, [containerRef])

  const resizeObserver = useMemo(() => {
    try {
      return new ResizeObserver(([{ contentRect: { height, width } }]) => {
        if (containerRef.current) setDimensions({ height, width })
      })
    } catch (e) {
      return undefined
    }
  }, [containerRef])

  useEffect(() => {
    window.addEventListener('resize', updateDimensions)
    if (watchElResize) resizeObserver?.observe(containerRef.current)
    return () => {
      window.removeEventListener('resize', updateDimensions)
      if (watchElResize && containerRef.current) resizeObserver?.unobserve(containerRef.current)
    }
  }, [containerRef])

  useEffect(() => {
    updateDimensions()
  }, [containerRef, updateDimensions])

  return dimensions
}
